import { hasNestedVerticalScrollbar } from "./hasNestedVerticalScrollbar";
import { hasVerticalScrollbar } from "./hasVerticalScrollbar";
import { isElementFullyInViewport } from "./isElementFullyInViewport";
import { scrollToElementWithOffset } from "./scrollToElementWithOffset";
/**
 * Scrolls to the element with an offset if the element is not in the viewport.
 * @param element
 * @param offset The offset is only applied without nested scrollbars
 * @returns
 */
export function scrollToElementIfNotInViewPort(element, offset = 0) {
    if (isElementFullyInViewport(element)) {
        return;
    }
    // if there are any nested vertical scrollbars, scroll to the element
    if (hasNestedVerticalScrollbar(element)) {
        return element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    // the scrolling with offset is only applied if the window has a vertical scrollbar
    if (hasVerticalScrollbar()) {
        return scrollToElementWithOffset(element, offset);
    }
}
//# sourceMappingURL=scrollToElementIfNotInViewPort.js.map